<div class="grid grid-cols-1 lg:grid-cols-12 xl:grid-cols-12 gap-x-20 my-24">
  <div class="lg:col-start-2 lg:col-span-5 xl:col-start-2">
    <h1
      class="self-stretch text-center xl:text-left text-gray-900 text-4xl font-extrabold font-['Inter'] leading-normal">
      A Casato Brasil é formada por uma equipe de designers, desenvolvedores e estrategistas dedicada a criar soluções tecnológicas para o mercado imobiliário brasileiro.
    </h1>
    <p
      class="self-stretch text-center xl:text-left text-gray-500 text-xl font-normal font-['Inter'] leading-loose mt-5">
      Comprometidos em transformar o acesso ao mercado imobiliário brasileiro. <br/></p>
  </div>
  <div class="col-span-1 lg:col-end-12 lg:col-span-5 xl:col-start-7">
    <p
      class="self-stretch text-center xl:text-left text-gray-500 text-xl font-normal font-['Inter'] leading-tight mb-5">
      Nossa história começou com o objetivo de tornar o acesso a imóveis em leilão mais simples, estruturado e transparente.
    <p
    class="self-stretch text-center xl:text-left text-gray-500 text-xl font-normal font-['Inter'] leading-tight mb-5">
    Desenvolvemos ferramentas que organizam informações, simulam cenários estimativos e facilitam o acompanhamento de oportunidades — seja na busca pelo primeiro imóvel ou na construção de estratégias de investimento.
    </p>
    <p class="self-stretch text-center xl:text-left text-gray-500 text-xl font-normal font-['Inter'] leading-tight">
      Casato Brasil — tecnologia e clareza para uma nova forma de acessar o mercado imobiliário.
    </p>
  </div>
</div>
<app-mission-template></app-mission-template>

<app-developed-for-template
  [sectionTitle]="developedForTitle"
  [sectionDescription]="developedForDescription"
  [items]="developedForItems">
</app-developed-for-template>

<app-why-choose-template></app-why-choose-template>
@if (!(authService.isLogged | async)) {
<div class="grid lg:grid-cols-12 sm:grid-cols-12 py-18 gap-10 px-10 lg:px-0">
  <div class="xs:col-span-12 sm:col-span-12 lg:col-start-3 lg:col-span-8">
    <div class="mx-auto max-w-3xl text-center">
      <h2 class="text-center text-gray-900 text-4xl font-extrabold font-['Inter'] leading-10">
        Encontre imóveis de leilão com mais clareza, rapidez e inteligência
      </h2>
      <p class="mt-4 text-center text-gray-500 text-xl font-normal font-['Inter'] leading-relaxed">
        Acesse oportunidades em todo o Brasil, receba alertas personalizados e analise imóveis com mais confiança.
      </p>
    </div>
    <div class="mt-5">
      <app-plans-template (planSelected)="handlePlanSelection($event)"></app-plans-template>
    </div>
  </div>
</div>
}

@if (!(authService.isLogged | async)) {
<app-trial-template (ctaSelected)="handleTrialSelection()"></app-trial-template>
}
